export default {
  FavoritesDialog: () =>
    import(
      /* webpackChunkName: "FavoritesDialog" */ '@/js/components/Navigation/components/FavoritesDialog.vue'
    ),
  FavoritesPageButton: () =>
    import(
      /* webpackChunkName: "FavoritesPageButton" */ '@/js/components/Navigation/components/FavoritesPageButton.vue'
    ),
  NavigationBikesList: () =>
    import(
      /* webpackChunkName: "NavigationBikesList" */ '@/js/components/Navigation/components/NavigationBikesList.vue'
    ),
  NavigationOutletList: () =>
    import(
      /* webpackChunkName: "NavigationOutletList" */ '@/js/components/Navigation/components/NavigationOutletList.vue'
    ),
  NavigationSparePartsList: () =>
    import(
      /* webpackChunkName: "NavigationSparePartsList" */ '@/js/components/Navigation/components/NavigationSparePartsList.vue'
    ),
  NavigationSparePartsSaleList: () =>
    import(
      /* webpackChunkName: "NavigationSparePartsSaleList" */ '@/js/components/Navigation/components/NavigationSparePartsSaleList.vue'
    ),
  NavigationArchiveList: () =>
    import(
      /* webpackChunkName: "NavigationArchiveList" */ '@/js/components/Navigation/components/NavigationArchiveList.vue'
    ),
  NavigationProductsList: () =>
    import(
      /* webpackChunkName: "NavigationProductsList" */ '@/js/components/Navigation/components/NavigationProductsList.vue'
    ),
  NavigationPageContent: () =>
    import(
      /* webpackChunkName: "NavigationPageContent" */ '@/js/components/Navigation/components/NavigationPageContent.vue'
    ),
  NavigationMessageCenter: () =>
    import(
      /* webpackChunkName: "NavigationMessageCenter" */ '@/js/components/Navigation/components/NavigationMessageCenter.vue'
    ),
  NavigationQuickBuy: () =>
    import(
      /* webpackChunkName: "NavigationQuickBuy" */ '@/js/components/Navigation/components/NavigationQuickBuy.vue'
    ),
  NavigationSerialNumberSearch: () =>
    import(
      /* webpackChunkName: "NavigationSerialNumberSearch" */ '@/js/components/Navigation/components/NavigationSerialNumberSearch.vue'
    ),
  NavigationCompareList: () =>
    import(
      /* webpackChunkName: "NavigationCompareList" */ '@/js/components/Navigation/components/NavigationCompareList.vue'
    ),
  NavigationSupportAccess: () =>
    import(
      /* webpackChunkName: "NavigationSupportAccess" */ '@/js/components/Navigation/components/NavigationSupportAccess.vue'
    ),
  NavigationMyData: () =>
    import(
      /* webpackChunkName: "NavigationMyData" */ '@/js/components/Navigation/components/NavigationMyData.vue'
    ),
  NavigationCompanyVacation: () =>
    import(
      /* webpackChunkName: "NavigationCompanyVacation" */ '@/js/components/Navigation/components/NavigationCompanyVacation.vue'
    ),
  NavigationCreditLimit: () =>
    import(
      /* webpackChunkName: "NavigationCreditLimit" */ '@/js/components/Navigation/components/NavigationCreditLimit.vue'
    ),
  NavigationOpenItems: () =>
    import(
      /* webpackChunkName: "NavigationOpenItems" */ '@/js/components/Navigation/components/NavigationOpenItems.vue'
    ),
  NavigationClickAndCollect: () =>
    import(
      /* webpackChunkName: "NavigationClickAndCollect" */ '@/js/components/Navigation/components/NavigationClickAndCollect.vue'
    ),
  StoreCheckList: () =>
    import(
      /* webpackChunkName: "StoreCheckList" */ '@/js/components/Account/StoreCheckList/StoreCheckList.vue'
    ),
  BlockingReasonDialog: () =>
    import(
      /* webpackChunkName: "BlockingReasonDialog" */ '@/js/components/Navigation/components/BlockingReasonDialog.vue'
    ),
  NavigationWarrantyComponents: () =>
    import(
      /* webpackChunkName: "NavigationWarrantyComponents" */ '@/js/components/Navigation/components/NavigationWarrantyComponents.vue'
    ),
  NavigationWarrantyReturns: () =>
    import(
      /* webpackChunkName: "NavigationWarrantyReturns" */ '@/js/components/Navigation/components/NavigationWarrantyReturns.vue'
    ),
  NavigationWarrantyBattery: () =>
    import(
      /* webpackChunkName: "NavigationWarrantyBattery" */ '@/js/components/Navigation/components/NavigationWarrantyBattery.vue'
    ),
  NavigationWarrantyEngine: () =>
    import(
      /* webpackChunkName: "NavigationWarrantyEngine" */ '@/js/components/Navigation/components/NavigationWarrantyEngine.vue'
    ),
  NavigationWarrantyWorktime: () =>
    import(
      /* webpackChunkName: "NavigationWarrantyWorktime" */ '@/js/components/Navigation/components/NavigationWarrantyWorktime.vue'
    ),
  NavigationUsermanagement: () =>
    import(
      /* webpackChunkName: "NavigationUsermanagement" */ '@/js/components/Navigation/components/NavigationUsermanagement.vue'
    ),
  NavigationDealerList: () =>
    import(
      /* webpackChunkName: "NavigationDealerList" */ '@/js/components/Navigation/components/NavigationDealerList.vue'
    ),
  NavigationPartnerEvents: () =>
    import(
      /* webpackChunkName: "NavigationPartnerEvents" */ '@/js/components/Navigation/components/NavigationPartnerEvents.vue'
    ),
  NavigationConnectedBike: () =>
    import(
      /* webpackChunkName: "NavigationConnectedBike" */ '@/js/components/Navigation/components/NavigationConnectedBike.vue'
    ),
}
